"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _Button = _interopRequireDefault(require("../../../Button"));
var _useFormContext = _interopRequireDefault(require("../../hooks/useFormContext"));
var _Icon = _interopRequireWildcard(require("../../../Icon"));
var _react = require("react");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var DeleteButton = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a = (0, _useFormContext.default)(),
    formDisabled = _a.disabled,
    getButtonLabel = _a.getButtonLabel,
    getFormData = _a.getFormData,
    isActing = _a.isActing,
    isDeleting = _a.isDeleting,
    onDelete = _a.onDelete,
    setIsDeleting = _a.setIsDeleting;
  var onClick = (0, _react.useCallback)(function () {
    if (onDelete) {
      setIsDeleting(true);
      onDelete(getFormData(), function () {
        setIsDeleting(false);
      });
    }
  }, [getFormData, onDelete, setIsDeleting]);
  return (0, _jsxRuntime.jsxs)(_Button.default, __assign({
    ref: ref,
    type: "button",
    disabled: formDisabled || isActing,
    onClick: onClick
  }, props, {
    children: [isDeleting && (0, _jsxRuntime.jsx)(_Icon.default, {
      spin: true,
      icon: _Icon.Icons.ArrowPath
    }), getButtonLabel("delete")]
  }));
});
var _default = DeleteButton;
exports.default = _default;